import React, { useEffect, useState } from 'react';
import api from '../api/client';

interface Product {
  id: number;
  name: string;
  sku: string;
  category_name: string;
  sell_price_uzs: number;
  cost_uzs?: number;
  stock: number;
  is_active: boolean;
}

const fmt = (n: number) => new Intl.NumberFormat('uz-UZ').format(n);

export const Products: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');
  const [count, setCount] = useState(0);

  const load = async (search = '') => {
    setLoading(true);
    try {
      const res = await api.get('/products/', { params: search ? { search } : {} });
      const data = res.data.results ?? res.data;
      setProducts(data);
      setCount(res.data.count ?? data.length);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Tovarlar</h1>
        <span className="text-sm text-gray-500">{count} ta</span>
      </div>

      <form
        onSubmit={(e) => { e.preventDefault(); load(q); }}
        className="mb-4 flex gap-2 max-w-md"
      >
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Nomi yoki SKU bo'yicha qidirish"
          className="input"
        />
        <button className="btn btn-primary">Qidirish</button>
      </form>

      {loading ? (
        <div className="text-center py-12 text-gray-500">Yuklanmoqda...</div>
      ) : (
        <div className="card overflow-x-auto p-0">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600 text-left">
              <tr>
                <th className="px-4 py-3">Nomi</th>
                <th className="px-4 py-3">SKU</th>
                <th className="px-4 py-3">Kategoriya</th>
                <th className="px-4 py-3 text-right">Tan narx</th>
                <th className="px-4 py-3 text-right">Sotish narx</th>
                <th className="px-4 py-3 text-right">Ombor</th>
                <th className="px-4 py-3">Holat</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {products.map((p) => (
                <tr key={p.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 font-medium text-gray-900">{p.name}</td>
                  <td className="px-4 py-3 text-gray-600">{p.sku}</td>
                  <td className="px-4 py-3 text-gray-600">{p.category_name}</td>
                  <td className="px-4 py-3 text-right text-gray-600">{p.cost_uzs != null ? fmt(p.cost_uzs) : '—'}</td>
                  <td className="px-4 py-3 text-right text-gray-900">{fmt(p.sell_price_uzs)}</td>
                  <td className="px-4 py-3 text-right">
                    <span className={p.stock <= 0 ? 'text-red-600 font-medium' : 'text-gray-600'}>{p.stock}</span>
                  </td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${p.is_active ? 'bg-success-100 text-success-700' : 'bg-gray-200 text-gray-600'}`}>
                      {p.is_active ? 'Faol' : 'Faol emas'}
                    </span>
                  </td>
                </tr>
              ))}
              {products.length === 0 && (
                <tr>
                  <td colSpan={7} className="px-4 py-8 text-center text-gray-500">Tovar topilmadi</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
